import { Component, computed, inject, Signal, signal, WritableSignal } from '@angular/core';
import { DashboardElement } from '../dashboard-element/dashboard-element';
import { Coaching, GpsOnly, VideoSection, Workout } from '@kinomap-dev/ng-ui-lib/core';
import { ContentListLightElement } from '../content-list-light-element/content-list-light-element';
import { EmptyContentListElement } from "../empty-content-list-element/empty-content-list-element";
import { ApiService } from '../../services/api.service';
import { HttpResourceRef } from '@angular/common/http';
import { UploadContentType } from '../../types/upload-content.type';


/**
 * **LastContent** est là pour afficher les dernier contenus posté par l'utilisateur, que ce soit
 * des **VideoSection, Coaching, Workout ou GpsOnly**. 
 * on affiche donc dans ce composant une liste d'une taille maximale de ces derniers uploads.
 * !!Pour le moment c'est Mock avec des data fake. Voir avec le Back pour nous faire un appel d'api 
 * ou si on peux faire avec l'existant!!
 */
@Component({
  selector: 'app-last-content',
  imports: [DashboardElement, ContentListLightElement, EmptyContentListElement],
  templateUrl: './last-content.html',
  styleUrl: './last-content.scss',
})
export class LastContent {
  private apiService: ApiService = inject(ApiService);

  private contentsRessources: HttpResourceRef<UploadContentType[] | undefined> = this.apiService.getUploadHistoryRessources;
  contents: Signal<UploadContentType[] | undefined> = this.contentsRessources?.value

  clientHaveContent: Signal<boolean> = computed(() => {
    const content: UploadContentType[] | undefined = this.contents();
    return content ? content.length > 0 : false;
  })
}
